export enum InsuranceApplicationStatus {
    Pending = 'pending',
    Unsupported = 'unsupported',
    Success = 'success',
    Failed = 'failed',
    Request = 'request',
}
